/* _word_ (or [word] in headings) becomes the italic accent in headings and titles; elsewhere the markers are removed */
(function(){
  var RE=/(^|[\s(“"'])_([^_<>]+?)_(?=$|[\s.,!?;:)”"'])/g, RB=/\[([^\]<>]+)\]/g;
  var TITLE='h1,h2,h3,h4,.lhs-heading,.fct-heading,.sst-title,.sr-title,.snl-title,[class*="-help-t"],[class*="title"]:not(title)';
  function fix(root){
    root=root||document.body; if(!root)return;
    var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{acceptNode:function(n){
      var p=n.parentElement; if(!p||p.closest('script,style,noscript,textarea,input,[contenteditable]'))return NodeFilter.FILTER_REJECT;
      RE.lastIndex=0; return (RE.test(n.nodeValue)||(p.closest('h1,h2,h3,h4')&&RB.test(n.nodeValue)))?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_SKIP}}),n,list=[];
    while(n=w.nextNode())list.push(n);
    list.forEach(function(t){
      var heading=t.parentElement.closest(TITLE);
      var isTitle=!!heading&&!heading.matches('button,a')&&!heading.closest('nav');
      if(!isTitle){ t.nodeValue=t.nodeValue.replace(RE,'$1$2'); return; }
      var html=t.nodeValue.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(RE,'$1<em>$2</em>');
      if(t.parentElement.closest('h1,h2,h3,h4')) html=html.replace(RB,'<em>$1</em>');
      var span=document.createElement('span'); span.innerHTML=html;
      while(span.firstChild) t.parentNode.insertBefore(span.firstChild,t);
      t.parentNode.removeChild(t);
    });
  }
  if(document.readyState!=='loading')fix(); else document.addEventListener('DOMContentLoaded',function(){fix()});
  document.addEventListener('shopify:section:load',function(e){fix(e.target)});
})();
